import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app'
import './index.css'

/**
 * Entry point.
 *
 * `StrictMode` is on intentionally — it surfaces effect/cleanup
 * bugs early in development and is a no-op in production. The
 * service worker registration happens through `vite-plugin-pwa`'s
 * auto-update flow (configured in `vite.config.ts`); no manual
 * `register()` call needed here.
 */

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Root element #root not found')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
